module.exports = __webpack_public_path__ + "img/image.536fffc5.svg";